import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Scissors } from 'lucide-react';

function SplitTaskDialog({ open, onClose, schedule, onConfirm }) {
  const [splitQuantity, setSplitQuantity] = useState('');
  const [error, setError] = useState('');

  const maxQty = schedule?.assigned_quantity || 0;

  useEffect(() => {
    if (open) {
      setSplitQuantity('');
      setError('');
    }
  }, [open]);

  const handleConfirm = () => {
    const qty = parseInt(splitQuantity, 10);
    if (isNaN(qty) || qty < 1 || qty >= maxQty) {
      setError(`拆分数量必须在 1 到 ${maxQty - 1} 之间`);
      return;
    }
    onConfirm(qty);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Scissors className="h-4 w-4" />
            拆分排程任务
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-2">
          {schedule && (
            <div className="text-sm text-gray-600 space-y-1">
              <div><span className="font-medium">工序:</span> {schedule.step_name}</div>
              <div><span className="font-medium">产品:</span> {schedule.finished_product_code}</div>
              <div><span className="font-medium">当前分配数量:</span> {schedule.assigned_quantity} 件</div>
            </div>
          )}

          <div className="space-y-2">
            <Label htmlFor="split-qty">拆分数量（新任务）</Label>
            <Input
              id="split-qty"
              type="number"
              min={1}
              max={maxQty - 1}
              value={splitQuantity}
              onChange={(e) => {
                setSplitQuantity(e.target.value);
                setError('');
              }}
              placeholder={`输入 1 ~ ${maxQty - 1}`}
            />
            {splitQuantity && !isNaN(parseInt(splitQuantity)) && (
              <div className="text-xs text-gray-500">
                原任务将变为 {maxQty - parseInt(splitQuantity)} 件，新任务为 {parseInt(splitQuantity)} 件
              </div>
            )}
            {error && <div className="text-xs text-red-500">{error}</div>}
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>取消</Button>
          <Button onClick={handleConfirm} disabled={!splitQuantity || !!error}>
            确认拆分
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default SplitTaskDialog;
